import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackQuoteAcceptedParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/quote/trackQuoteAccepted";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackQuoteAccepted = (
    parameters: PartialSpecific<TrackQuoteAcceptedParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackQuoteAcceptedParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        quote: ga.use.quote(options),
        ...options,
    };

    return (parameters: Partial<TrackQuoteAcceptedParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.quoteAccepted({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackQuoteAccepted;
